'use strict';

/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

// ----------------------------------------
// Imports
// ----------------------------------------

import 'malihu-custom-scrollbar-plugin';

// ----------------------------------------
// Private
// ----------------------------------------

let $scrollbar = $('.table-scroll');
let $tip = $('.scroll-tip');
let $close = $('.scroll-tip__close-btn');
let e_top;
let show = true;

if ($scrollbar.length) {
	e_top = $scrollbar.offset().top;
}

function showTip () {
	$tip.fadeIn('fast');
}

function hideTip () {
	$tip.fadeOut('fast');
}

// ----------------------------------------
// Public
// ----------------------------------------

function initScrollbar () {
	if (!$scrollbar) {
		return false;
	}

	if ($(window).width() > 1023) {
		return false;
	}

	$scrollbar.mCustomScrollbar({
		axis: 'x',
		scrollbarPosition: 'inside',
		theme: 'rounded-dark',
		advanced: {
			updateOnSelectorChange: 'table'
		},
		callbacks: {
			onOverflowXNone: function () {
				console.log('Horizontal scrolling is not required');
			},
			onCreate: function () {
				console.log('Plugin markup generated');
			},
			onOverflowX: function () {
				console.log('Horizontal scrolling required');
			}
		}
	});
}

function scrollTip () {
	if (!show) {
		return false;
	}

	if (!$scrollbar) {
		show = false;

		return false;
	}

	if ($scrollbar.hasClass('mCS_no_scrollbar')) {
		show = false;

		return false;
	}

	let w_top = $(window).scrollTop();

	if (w_top >= e_top) {
		showTip();

		show = false;
	}

	setTimeout(function () {
		hideTip();
	}, 8000);
}

function closeTip () {
	$close.on('click', hideTip);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export {initScrollbar};



// WEBPACK FOOTER //
// ./src/js/_modules/scrollbar.js